var $85a5f86b715fe7db$exports = {};
const $85a5f86b715fe7db$var$toggle = document.querySelector(".nav__toggle");
const $85a5f86b715fe7db$var$menu = document.querySelector(".nav__menu");
const $85a5f86b715fe7db$var$showMenu = ()=>{
    $85a5f86b715fe7db$var$menu.classList.add("nav__menu--is-active");
    $85a5f86b715fe7db$var$toggle.setAttribute("aria-expanded", "true");
};
const $85a5f86b715fe7db$var$hideMenu = ()=>{
    $85a5f86b715fe7db$var$toggle.setAttribute("aria-expanded", "false");
    $85a5f86b715fe7db$var$menu.classList.remove("nav__menu--is-active");
};
$85a5f86b715fe7db$var$toggle.addEventListener("click", ()=>{
    if ($85a5f86b715fe7db$var$menu.classList.contains("nav__menu--is-active")) $85a5f86b715fe7db$var$hideMenu();
    else $85a5f86b715fe7db$var$showMenu();
});
$85a5f86b715fe7db$var$menu.addEventListener("click", (e)=>{
    if (e.target.closest(".nav__menu-link")) $85a5f86b715fe7db$var$hideMenu();
});
const $85a5f86b715fe7db$var$headerBar = document.querySelector(".header__bar");
const $85a5f86b715fe7db$var$nav = document.querySelector(".nav");
const $85a5f86b715fe7db$var$observer = new IntersectionObserver((entries, observer)=>{
    entries.forEach((entry)=>{
        $85a5f86b715fe7db$var$nav.classList.toggle("nav--is-stuck", !entry.isIntersecting);
    });
}, {
    threshold: 0
});
$85a5f86b715fe7db$var$observer.observe($85a5f86b715fe7db$var$headerBar);


//# sourceMappingURL=index.d19d6fcc.js.map
